// extracted by mini-css-extract-plugin
export default {"CTA":"styles_CTA__zQAHm","float_up":"styles_float_up__hU1EN","CTAsmall":"styles_CTAsmall__iRgy6","StepHeading":"styles_StepHeading__6AP8m"};